export default {
	emitter: {
		closeTab: "closeTab",
		closeWidget: "closeWidget",
		openWidget: "openWidget",
		desktopNotificationPermission: "desktopNotificationPermission",
		initializeWidget: "initializeWidget",
		identityVerified: "identityVerified",
		languageChange: "languageChange",
		locationChange: "locationChange",
		parentSize: "parentSize",
		refresh: "refresh",
		urlChange: "urlChange",
	},
	listener: {
		cancelLocationWatch: "cancelLocationWatch",
		closeWidget: "closeWidget",
		openWidget: "openWidget",
		showWidget: "showWidget",
		hideWidget: "hideWidget",
		newMessage: "newMessage",
		resetMessages: "resetMessages",
		requestDeskNotificationPermission: "requestDeskNotificationPermission",
		requestLocation: "requestLocation",
		requestParentSize: "requestParentSize",
		sendDesktopNotification: "sendDesktopNotification",
		settingsChange: "settingsChange",
		startTabbarNotification: "startTabbarNotification",
		stopTabbarNotification: "stopTabbarNotification",
		styleChange: "styleChange",
		widgetInit: "widgetInit",
	},
	controllerOptions: {
		onWidgetOpen: "onWidgetOpen",
		onWidgetClose: "onWidgetClose",
	},
};
